import { BehaviorSubject, Subject } from 'rxjs'

export class LoadingService extends BehaviorSubject<boolean> {
  static globalActivity$ = new Subject()

  activeRequests = 0
  constructor(public name: string) {
    super(false)
  }

  emit() {
    if (this.activeRequests < 0) { this.activeRequests = 0 }
    const isLoading = this.activeRequests > 0
    if (this.value !== isLoading) {
      LoadingService.globalActivity$.next({ isLoading, name: this.name })
      this.next(isLoading)
    }
  }

  startRequest() {
    this.activeRequests++
    this.emit()
  }

  completeRequest() {
    this.activeRequests--
    this.emit()
  }
}
